import { nanoid } from "nanoid";

export const CLIENT_ID_HEADER = "X-Client-Id";

/**
 * Identifies this tab to the backend: sent on every API request and on the
 * realtime handshake. The tab that made a change has already applied it
 * optimistically, so the server leaves it out of that change's broadcast.
 *
 * Kept in memory on purpose: sessionStorage is copied when a tab is duplicated,
 * and two tabs sharing an id would each miss the other's changes. nanoid rather
 * than crypto.randomUUID, which is missing outside secure contexts.
 */
export const CLIENT_ID: string = nanoid();
